import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initSwipers() {

    // ---------------------------------------
    // Testimonials Swiper
    // ---------------------------------------
    document.querySelectorAll('.testimonials-slider').forEach(block => {
        const swiperEl = block.querySelector('.testimonialsSwiper');
        const next = block.querySelector('.testimonialsSwiper-next');
        const prev = block.querySelector('.testimonialsSwiper-prev');

        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                651: { slidesPerView: 2 },
                1101: { slidesPerView: 3 },
            },
        });
    });

    // ---------------------------------------
    // Steps Swiper
    // ---------------------------------------
    document.querySelectorAll('.steps-slider').forEach(block => {
        const swiperEl = block.querySelector('.stepsSwiper');
        const next = block.querySelector('.stepsSwiper-next');
        const prev = block.querySelector('.stepsSwiper-prev');

        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                601: { slidesPerView: 2 },
                1101: { slidesPerView: 3 },
            },
        });
    });

    // ---------------------------------------
    // What's New Swiper
    // ---------------------------------------
    document.querySelectorAll('.whatsnew-slider').forEach(block => {
        const swiperEl = block.querySelector('.whatsNewSwiper');
        const next = block.querySelector('.whatsNewSwiperPagination-next');
        const prev = block.querySelector('.whatsNewSwiperPagination-prev');

        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 40,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                601: { slidesPerView: 2 },
                1101: { slidesPerView: 4 },
            },
        });
    });
}